import { useTheme, useMediaQuery } from '@mui/material';
import ScadenzaCalendarPageDesktop from './ScadenzaCalendarPageDesktop';
import ScadenzaCalendarPageMobile from './ScadenzaCalendarPageMobile';

export default function ScadenzaCalendarPage() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return isMobile
    ? <ScadenzaCalendarPageMobile />
    : <ScadenzaCalendarPageDesktop />;
}